/*
 *
 * ChannelsPage actions
 *
 */

import {
  SET_CLIENT_FILTER,
  SET_STATUS_FILTER,
  FETCH_CHANNELS_REQUEST,
  FETCH_CHANNELS_SUCCESS,
  FETCH_CHANNEL_DETAIL_REQUEST,
  FETCH_UPDATED_CHANNEL_DETAIL_REQUEST,
  FETCH_SLUG_VALIDATE_REQUEST,
  FETCH_SLUG_VALIDATE_SUCCESS,
  FETCH_SLUG_VALIDATE_FAILURE,
  FETCH_CHANNEL_DETAIL_SUCCESS,
  FETCH_CHANNELS_FAILURE,
  POST_CHANNEL_REQUEST,
  PUT_CHANNEL_SUCCESS,
  PUT_CHANNEL_FAILURE,
  FETCH_CLIENTS_REQUEST,
  FETCH_CLIENTS_SUCCESS,
  FETCH_CLIENTS_FAILURE,
  PATCH_CHANNEL_REQUEST,
  PATCH_CHANNEL_SUCCESS,
  CHANGE_TAB,
  FETCH_THEMES_REQUEST,
  FETCH_THEMES_SUCCESS,
  FETCH_THEMES_FAILURE,
  FETCH_MODES_REQUEST,
  FETCH_MODES_SUCCESS,
  FETCH_MODES_FAILURE,
  DELETE_CHANNEL_REQUEST,
  DELETE_CHANNEL_SUCCESS,
  DELETE_CHANNEL_FAILURE,
} from './constants';

export const setClientFilter = (payload) => ({
  type: SET_CLIENT_FILTER,
  payload,
});

export const setStatusFilter = (payload) => ({
  type: SET_STATUS_FILTER,
  payload,
});
export const changeTab = (payload) => ({
  type: CHANGE_TAB,
  payload,
});

export const fetchChannelsRequest = (params = null) => ({
  type: FETCH_CHANNELS_REQUEST,
  params,
});

export const fetchChannelsSuccess = (payload) => ({
  type: FETCH_CHANNELS_SUCCESS,
  payload
});

export const fetchChannelDetailRequest = (channelId) => ({
  type: FETCH_CHANNEL_DETAIL_REQUEST,
  id: channelId,
});

export const fetchUpdatedChannelDetailRequest = (channelId) => ({
  type: FETCH_UPDATED_CHANNEL_DETAIL_REQUEST,
  id: channelId,
})

export const validateChannelSlugRequest = (channelId) => {
  return ({
  type: FETCH_SLUG_VALIDATE_REQUEST,
  id: channelId,
})};

export const validateChannelSlugFailure = (payload) => ({
  type: FETCH_SLUG_VALIDATE_FAILURE,
  payload
});

export const validateChannelSlugSuccess = (payload) => ({
  type: FETCH_SLUG_VALIDATE_SUCCESS,
  payload
});

export const fetchChannelDetailSuccess = (payload) => ({
  type: FETCH_CHANNEL_DETAIL_SUCCESS,
  payload
});

export const fetchChannelsFailure = () => ({
  type: FETCH_CHANNELS_FAILURE,
});

export const postChannelRequest = (payload) => ({
  type: POST_CHANNEL_REQUEST,
  payload
});

export const putChannelSuccess = (payload) => ({
  type: PUT_CHANNEL_SUCCESS,
  payload
});

export const putChannelFailure = ({ errors }) => ({
  type: PUT_CHANNEL_FAILURE,
  payload: {
    errors
  }
});

export const fetchClientsRequest = ({ q }) => ({
  type: FETCH_CLIENTS_REQUEST,
  payload: {
    q,
  }
});

export const fetchClientsSuccess = (payload) => ({
  type: FETCH_CLIENTS_SUCCESS,
  payload
});

export const fetchClientsFailure = () => ({
  type: FETCH_CLIENTS_FAILURE,
});

export const patchChannelRequest = ({ id, data }) => ({
  type: PATCH_CHANNEL_REQUEST,
  payload: {
    id,
    data,
  }
});
export const patchChannelSuccess = (payload) => ({
  type: PATCH_CHANNEL_SUCCESS,
  payload
});

export const fetchThemesRequest = () => ({
  type: FETCH_THEMES_REQUEST,
});

export const fetchThemesSuccess = (payload) => ({
  type: FETCH_THEMES_SUCCESS,
  payload
});

export const fetchThemesFailure = () => ({
  type: FETCH_THEMES_FAILURE,
});

export const fetchModesRequest = () => ({
  type: FETCH_MODES_REQUEST,
});

export const fetchModesSuccess = (payload) => ({
  type: FETCH_MODES_SUCCESS,
  payload
});

export const fetchModesFailure = () => ({
  type: FETCH_MODES_FAILURE,
});

export const deleteChannelRequest = (payload) => ({
  type: DELETE_CHANNEL_REQUEST,
  channelId: payload,
  });

export const deleteChannelSuccess = (payload) => ({
  type: DELETE_CHANNEL_SUCCESS,
  payload,
});

export const deleteChannelFailure = () => ({
  type: DELETE_CHANNEL_FAILURE,
});



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/actions.js